import { connect } from 'react-redux';
import Login from './Login.layout';

import { login } from '../../redux';

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    success: state.auth.success,
    error: state.auth.error,
  };
};

const mapDispatchToProps = {
  onLogin: login,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Login/Login.connect.jsx